var map = {
	"./b027site/home/home.vue": [
		546,
		3
	],
	"./b027sport/home/home.vue": [
		547,
		2
	],
	"./betl/home/home.vue": [
		548,
		1
	],
	"./common/home/home.vue": [
		549,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 454;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/different lazy ^\.\/.*\/home\/home\.vue$
// module id = 454
// module chunks = 13